import { find, findLast, path, sortBy } from 'ramda';

const findLowerTariff = ({ tariffs, quota }) => {
    return findLast((tariff) => tariff.space.original < quota, sortBy(path(['space', 'original']), tariffs));
};

const findHigherTariff = ({ tariffs, quota, period }) => {
    const sortedTariffs = sortBy(path(['space', 'original']), tariffs);

    if (period) {
        return find((tariff) => {
            return tariff.space.original > quota && tariff.products.find((product) => product.period === period);
        }, sortedTariffs);
    }

    return find((tariff) => tariff.space.original > quota, sortedTariffs);
};

export { findHigherTariff, findLowerTariff };
